import { Poker2Constants } from "../Poker2Constants";
import { PokerGameTypes } from "../PokerGameTypes";
import { GameTypeAbstract } from "./GameTypeAbstract";

export class GameTypeMapper {
    /**
     * Maps the integer ids for the tournament id to the in-game used GameTypeAbstract based classes.
     * Checks also if the user joins as a spectator.
     *
     * Supported ids:
     * 0 = shootout
     * 1 = freezeout
     * 2 = rebuy
     *
     * @param id Id of the tournament type of backend.
     * @return Mapped GameTypeAbstract class
     */
    public static mapTournamentType(id: number, isSpectator: boolean): GameTypeAbstract {
        var type: GameTypeAbstract;

        switch (id) {
            case 0:

                type = (!isSpectator) ? PokerGameTypes.TOURNAMENT_TYPE_SHOOTOUT : PokerGameTypes.TOURNAMENT_TYPE_SHOOTOUT_SPECTATOR;
                break;

            case 1:

                type = (!isSpectator) ? PokerGameTypes.TOURNAMENT_TYPE_FREEZEOUT : PokerGameTypes.TOURNAMENT_TYPE_FREEZEOUT_SPECTATOR;
                break;

            case 2:

                type = (!isSpectator) ? PokerGameTypes.TOURNAMENT_TYPE_REBUY : PokerGameTypes.TOURNAMENT_TYPE_REBUY_SPECTATOR;
                break;

            default:

                type = (!isSpectator) ? PokerGameTypes.TOURNAMENT_TYPE_SHOOTOUT : PokerGameTypes.TOURNAMENT_TYPE_SHOOTOUT_SPECTATOR;
        }

        return type;
    }

    /**
     * Maps the integer ids for the table id to the in-game used GameTypeAbstract based classes.
     *
     * Supported ids:
     * 0 = standard
     * 1 = fast
     * 2 = Min50BB
     *
     * @param id Id of the table type of backend.
     * @return Mapped GameTypeAbstract class
     */
    public static mapTableType(id: number): GameTypeAbstract {
        var type: GameTypeAbstract;

        switch (id) {
            case 0:

                type = PokerGameTypes.DEFAULT_TABLE_TYPE_STANDARD;
                break;

            case 1:

                type = PokerGameTypes.DEFAULT_TABLE_TYPE_FAST;
                break;

            case 2:

                type = PokerGameTypes.DEFAULT_TABLE_TYPE_MIN50BB;
                break;

            default:

                type = PokerGameTypes.DEFAULT_TABLE_TYPE_STANDARD;
        }

        return type;
    }
}
